import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel, NewUserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel, PassChange } from '../../_models/auth.model';
import { MenuPermission } from '../../_models/menupermission.model';
import { Config } from "../../../../pages/_models/config.model"

const API_USERS_URL = `${environment.apiUrl}/Entidad/get_login?`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  apiUrls = {
    getLogin : `${environment.url}/${environment.apiUrl}/Entidad/get_login?`,
    getUserInfo : `${environment.url}/${environment.apiUrl}/Entidad/get_user_info?`,
    createUser : `${environment.url}/${environment.apiUrl}/Entidad/post_solicitud_usuario?`,
    createUser2: `${environment.url}/${environment.apiUrl}/Entidad/post_crear_usuario_corredor?`,
    forgotPassword: `${environment.url}/${environment.apiUrl}/Entidad/get_codigo_cambio_clave?`,
    forgotPassword2: `${environment.url}/${environment.apiUrl}/Entidad/get_codigo_cambio_clave_usuario?`,
    changePassword: `${environment.url}/${environment.apiUrl}/Entidad/post_cambio_clave`,
    changePassword2: `${environment.url}/${environment.apiUrl}/Entidad/post_cambio_clave_usuario`,
    getMenuPermission : `${environment.url}/${environment.apiUrl}/Entidad/get_permiso_menu?`,
    getLoginCode: `${environment.url}/${environment.apiUrl}/Entidad/get_login_email_telefono?`,
  }

  constructor(private http: HttpClient) { }

  // public methods
  /*
  login(email: string, password: string): Observable<any> {
      let formData = new FormData();
      formData.append("Usuario", email);
      formData.append("Clave", password);
    return this.http.post<AuthModel>(this.apiUrls.getLoginCode, formData);
  }
*/
  login(code: string, codelogin: string): Observable<any> {
    let formData = new FormData();
    formData.append("Codigo", code);
    formData.append("IdCodigoLogin", codelogin);
  return this.http.post<any>(this.apiUrls.getLoginCode, formData);
}

  createUser(user: NewUserModel): Observable<NewUserModel> {
    var form = new FormData();
    form.append("data", JSON.stringify([user]));
    return this.http.post<NewUserModel>(this.apiUrls.createUser, form);
  }

  createUserMode2(data, httpHeaders): Observable<NewUserModel> {
    return this.http.post<NewUserModel>(this.apiUrls.createUser2, data, {headers: httpHeaders});
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<PassChange> {
    return this.http.get<PassChange>(this.apiUrls.forgotPassword + "usuario=" + email);
  }

  forgotPasswordMode2(httpHeaders): Observable<PassChange> {
    return this.http.get<PassChange>(this.apiUrls.forgotPassword2, {headers: httpHeaders});
  }

  changePassword(data: FormData): Observable<PassChange> {
    return this.http.post<PassChange>(this.apiUrls.changePassword, data);
  }

  changePasswordMode2(data: FormData, httpHeaders): Observable<PassChange> {
    return this.http.post<PassChange>(this.apiUrls.changePassword2, data, {headers: httpHeaders});
  }

  getUserByToken(httpHeaders): Observable<UserModel> {
    return this.http.get<UserModel>(this.apiUrls.getUserInfo, {
      headers: httpHeaders,
    });
  }

  getMenuPermission(httpHeaders): Observable<MenuPermission> {
    return this.http.get<MenuPermission>(this.apiUrls.getMenuPermission, {
      headers: httpHeaders,
    });
  }
/*
  // READ
  async getMenuPermission(paramsGet: string = "", httpHeaders) {
    return await this.http.get<Config>(this.apiUrls.getMenuPermission + paramsGet, {headers: httpHeaders}).toPromise();
  }
*/

}
